import { MenuItem } from "@mui/material";
import React from "react";
import styles from "../MenuItem.module.css";

const MenuItemChangeProject = ({ menuItem, onSelect }) => {
	const handleSelect = () => {
		const link = {
			name: menuItem.name,
			to: menuItem.hasRoleOnDocument
				? `/projects/${menuItem.id}/dashboard/review-progress`
				: `/projects/${menuItem.id}/dashboard/project`,
		};
		onSelect(link);
	};
	return (
		<MenuItem className={styles.menuItem} translate="no" onClick={handleSelect}>
			- {menuItem.name}
		</MenuItem>
	);
};
export default MenuItemChangeProject;
